/**
 * One promotion-lock subscriber per page.
 *
 * `useGamePromoLock` used to open its own react-query subscriptions per tile, so
 * a lottery or casino grid of a few hundred cards carried that many observers on
 * two shared keys to compute one answer they all agree on (#524). This resolves
 * it once at the shell and hands the same verdict down.
 */
import type { ReactNode } from 'react';
import { GamePromoLockContext, useGamePromoLockValue } from './use-game-lock.js';

export function GamePromoLockProvider({ children }: { children: ReactNode }) {
  const lock = useGamePromoLockValue();
  return <GamePromoLockContext.Provider value={lock}>{children}</GamePromoLockContext.Provider>;
}
